const getSectorTypeName = (type) => {
  switch (type) {
    case 'generic':
      return 'Generic'
    case 'free_bet':
      return 'Freebet'
    case 'promo_code':
      return 'Promo code'
    case 're_spin':
      return 'Re-spin'
    case 'promo_code_unique':
      return 'Unique promo code'
    default:
      return '—'
  }
}

export { getSectorTypeName }
